module.exports = __webpack_public_path__ + "img/rocket-top-smoke.2016e5e5.png";